var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8906 5.85938C12.1368 5.85938 11.5234 5.24605 11.5234 4.49219V0H4.53125C3.3466 0 2.38281 0.963789 2.38281 2.14844V17.8516C2.38281 19.0362 3.3466 20 4.53125 20H15.4688C16.6534 20 17.6172 19.0362 17.6172 17.8516V5.85938H12.8906ZM5.58594 14.0625H8.42656C8.75016 14.0625 9.0125 14.3248 9.0125 14.6484C9.0125 14.972 8.75016 15.2344 8.42656 15.2344H5.58594C5.26234 15.2344 5 14.972 5 14.6484C5 14.3248 5.26234 14.0625 5.58594 14.0625ZM5 11.5234C5 11.1998 5.26234 10.9375 5.58594 10.9375H14.1797C14.5033 10.9375 14.7656 11.1998 14.7656 11.5234C14.7656 11.847 14.5033 12.1094 14.1797 12.1094H5.58594C5.26234 12.1094 5 11.847 5 11.5234ZM14.1797 7.8125C14.5033 7.8125 14.7656 8.07484 14.7656 8.39844C14.7656 8.72203 14.5033 8.98438 14.1797 8.98438H5.58594C5.26234 8.98438 5 8.72203 5 8.39844C5 8.07484 5.26234 7.8125 5.58594 7.8125H14.1797Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6953 4.49137C12.6953 4.59906 12.7829 4.68668 12.8906 4.68668H17.356C17.2488 4.48879 17.1109 4.30703 16.9453 4.15027L13.1788 0.586914C13.0326 0.448633 12.8698 0.333281 12.6954 0.242188V4.49137H12.6953Z",
    fill: "#1D4650"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.75e73c67cede6ee9962cc15e39c3209c.svg";
export { ForwardRef as ReactComponent };